import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BadgeComponent } from '@domgen/dgx-fe-components/badge';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { CurrencyFormatPipe, TranslatePipe } from '@domgen/dgx-fe-i18n';
import { QuoteOfferPriceDiscountedPipe } from '@us-registration/data-access';

@Component({
  selector: 'us-registration-protection-details-quote-offer',
  templateUrl: './protection-details-quote-offer.component.html',
  styleUrls: ['./protection-details-quote-offer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BadgeComponent,
    CurrencyFormatPipe,
    IconComponent,
    NgIf,
    NgTemplateOutlet,
    QuoteOfferPriceDiscountedPipe,
    TranslatePipe,
  ],
})
export class ProtectionDetailsQuoteOfferComponent {
  @Input() promotionActive = false;
  @Input() quoteBrand?: string;
  @Input() quoteOriginalPrice?: number;
  @Input() stacked = false;
  @Input() discountedMonthPercentage?: number;
  @Input() discountedMonthsCount?: number;
}
